import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Snackbar,
  Alert,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Button, Container, Title } from "./styles";
import { Box } from "@mui/system";
import { useUser } from "../../contexts/UserContext";
import Translator from "../../components/i18nComponents/Translator";
import { useTranslation } from "react-i18next";

export default function BuyRobot() {
  const { handleBuyRobot, paymentLink } = useUser();
  const [sellerID, setSellerID] = useState(null);
  const [subscriptionID, setSubscriptionID] = useState(null);
  const [userIDL, setUserIDL] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("Mercado Pago");
  const [currency, setCurrency] = useState("usd");
  const [customPlan, setCustomPlan] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [customerName, setCustomerName] = useState("");
  const [customerCPF, setCustomerCPF] = useState("");

  const userid = localStorage.getItem("userId");
  const sellerID2 = localStorage.getItem("sellerID");
  const { t } = useTranslation();

  useEffect(() => {
    if (userid) setUserIDL(userid);
    if (sellerID2) {
      setSellerID(sellerID2);
    } else {
      const windowUrl = window.location.search;
      const params = new URLSearchParams(windowUrl);
      const vendid = params.get("sellerid");

      if (vendid && vendid !== userid) {
        setSellerID(vendid);
        localStorage.setItem("sellerID", vendid);
      }
    }

    // --- ADICIONADO: Carrega os dados do cliente do localStorage ---
    const savedName = localStorage.getItem("customerName");
    const savedCPF = localStorage.getItem("customerCPF");
    if (savedName) {
      setCustomerName(savedName);
    }
    if (savedCPF) {
      setCustomerCPF(savedCPF);
    }
  }, [userid, sellerID2]);

  const handleBuyButton = () => {
    if (!userIDL) {
      setErrorMessage(t("paginas.buyRobot.erroIdTelegram"));
      setSnackbarOpen(true);
      return;
    }
   
    if (paymentMethod === "Asaas" && (!customerName || !customerCPF)) {
        setErrorMessage("Por favor, preencha seu nome e CPF/CNPJ para pagamento com Pix.");
        setSnackbarOpen(true);
        return;
    }

    if (!subscriptionID) {
      setErrorMessage(t("paginas.buyRobot.erroPlano"));
      setSnackbarOpen(true);
      return;
    }

    if (!paymentMethod) {
      setErrorMessage(t("paginas.buyRobot.erroMetodoPagamento"));
      setSnackbarOpen(true);
      return;
    }

    if (quantity < 5 && customPlan) {
      setErrorMessage(t("paginas.buyRobot.erroQtnMin"));
      setSnackbarOpen(true);
      return;
    }

    localStorage.setItem("userId", userIDL);
    localStorage.setItem("traderId", userIDL);

    // --- ADICIONADO: Salva os dados do cliente no localStorage ---
    if (paymentMethod === "Asaas") {
      localStorage.setItem("customerName", customerName);
      localStorage.setItem("customerCPF", customerCPF);
    }

    handleBuyRobot(
        userIDL, 
        subscriptionID, 
        sellerID, 
        paymentMethod, 
        currency, 
        quantity,
        customerName,
        customerCPF
    );
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
    setErrorMessage("");
  };

  const planosLength =
    paymentMethod === "Crypto" || (paymentMethod === "Stripe" && currency === "usd")
      ? 9
      : 11;

  return (
    <Container>
      <Title>
        <Translator path="paginas.buyRobot.Title" />
      </Title>

      <FormControlLabel
        control={
          <Checkbox
            checked={customPlan}
            onChange={(e) => {
              setCustomPlan(e.target.checked);
              if (!e.target.checked) {
                setQuantity(0);
              }
            }}
          />
        }
        label={t("paginas.buyRobot.customPlan")}
      />
      <br />
      <br />

      <FormControl sx={{ minWidth: "100%", marginBottom: 2 }} size="small">
        <InputLabel id="payment-method-label">
          <Translator path="paginas.buyRobot.textMetodo" />
        </InputLabel>
        <Select
          labelId="payment-method-label"
          id="payment-method-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value);
            setSubscriptionID(null);
            if (e.target.value !== "Stripe") {
              setCurrency("brl");
            }
          }}
        >
          <MenuItem value="Asaas">Asaas (Pix)</MenuItem>
          <MenuItem value="Mercado Pago">Mercado Pago</MenuItem>
          <MenuItem value="Stripe">Stripe</MenuItem>
          <MenuItem value="Crypto">Crypto</MenuItem>
          <MenuItem value="Paypal">Paypal</MenuItem>
        </Select>
      </FormControl>

      {paymentMethod === "Stripe" && (
        <FormControl sx={{ minWidth: "100%", marginBottom: 2 }} size="small">
          <InputLabel id="currency-select-label">
            <Translator path="paginas.buyRobot.textMoeda" />
          </InputLabel>
          <Select
            labelId="currency-select-label"
            id="currency-select"
            value={currency}
            onChange={(e) => {
              setCurrency(e.target.value.toLowerCase());
              setSubscriptionID(null);
            }}
          >
            <MenuItem value="brl">BRL</MenuItem>
            <MenuItem value="usd">USD</MenuItem>
          </Select>
        </FormControl>
      )}


      {!customPlan ? (
        <FormControl sx={{ minWidth: "100%" }} size="small">
          <InputLabel id="subscription-select-label">
            <Translator path="paginas.buyRobot.textTipoDePlano" />
          </InputLabel>
          <Select
            labelId="subscription-select-label"
            id="subscription-select"
            value={subscriptionID}
            onChange={(e) => setSubscriptionID(e.target.value)}
            required
          >
            {Array.from({ length: planosLength }, (_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                <Translator
                  path={
                    paymentMethod === "Crypto" ||
                    (paymentMethod === "Stripe" && currency === "usd")
                      ? `paginas.buyRobot.crypto.plano${i + 1}`
                      : `paginas.buyRobot.brl.plano${i + 1}`
                  }
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <TextField
            fullWidth
            label={t("paginas.buyRobot.labelQuantidadeBots")}
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            variant="filled"
            sx={{ marginBottom: 2 }}
          />
          <FormControl sx={{ minWidth: "100%" }} size="small">
            <InputLabel id="subscription-days-label">
              <Translator path="paginas.buyRobot.textQuantidadeDias" />
            </InputLabel>
            <Select
              labelId="subscription-days-label"
              id="subscription-days-select"
              value={subscriptionID}
              onChange={(e) => setSubscriptionID(e.target.value)}
            >
              {Array.from({ length: 4 }, (_, i) => (
                <MenuItem key={i + 1} value={i + 1}>
                  <Translator path={`paginas.buyRobot.dias.plano${i + 1}`} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}

      {paymentMethod === "Asaas" && (
        <Box sx={{ width: "100%", marginY: 2 }}>
            <TextField
                required
                fullWidth
                label="Nome"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                variant="filled"
                sx={{ marginBottom: 2 }}
            />
            <TextField
                required
                fullWidth
                label="CPF ou CNPJ"
                value={customerCPF}
                onChange={(e) => setCustomerCPF(e.target.value)}
                variant="filled"
            />
        </Box>
      )}

      <Box component="form" sx={{ width: "100%", marginY: 2 }} noValidate autoComplete="off">
        <TextField
          required
          fullWidth
          label={t("paginas.buyRobot.labelIdTelegram")}
          value={userIDL || ""}
          type="number"
          disabled
          variant="filled"
        />
      </Box>

      <Button
        onClick={handleBuyButton}
        disabled={
          !userIDL ||
          !subscriptionID ||
          !paymentMethod ||
          (paymentMethod === "Crypto" && currency === "brl")
        }
      >
        <Translator path="paginas.buyRobot.buttonGerarLink" />
      </Button>

      {paymentLink && <a href={paymentLink}>{t("paginas.buyRobot.linkPagamento")}</a>}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}